import BankDetailsActionTypes from './bank-details.types';

/** ***************** ADD BUSINESS BANK START *********************** */
export const addBusinessBankStart = (bankData: any) => ({
	type: BankDetailsActionTypes.ADD_BUSINESS_BANK_START,
	payload: bankData,
});

export const addBusinessBankSuccess = (successValue: any) => ({
	type: BankDetailsActionTypes.ADD_BUSINESS_BANK_SUCCESS,
	payload: successValue,
});

export const addBusinessBankFailure = (failureData: any) => ({
	type: BankDetailsActionTypes.ADD_BUSINESS_BANK_FAILURE,
	payload: failureData,
});

export const addBusinessBankResponseResetStart = () => ({
	type: BankDetailsActionTypes.ADD_BUSINESS_BANK_RESPONSE_RESET,
});

export const addBusinessBankResponseChanged = () => ({
	type: BankDetailsActionTypes.ADD_BUSINESS_BANK_RESPONSE_CHANGED,
});
/** ***************** ADD BUSINESS BANK END *********************** */

/** ***************** FETCH BUSINESS BANK START *********************** */
export const fetchBusinessBankStart = (fetchData: any) => ({
	type: BankDetailsActionTypes.FETCH_BUSINESS_BANK_START,
	payload: fetchData,
});

export const fetchBusinessBankSuccess = (successData: any) => ({
	type: BankDetailsActionTypes.FETCH_BUSINESS_BANK_SUCCESS,
	payload: successData,
});

export const fetchBusinessBankFailure = (failureData: any) => ({
	type: BankDetailsActionTypes.FETCH_BUSINESS_BANK_FAILURE,
	payload: failureData,
});

export const fetchBusinessBankResponseResetStart = () => ({
	type: BankDetailsActionTypes.FETCH_BUSINESS_BANK_RESPONSE_RESET,
});

export const fetchBusinessBankResponseChanged = () => ({
	type: BankDetailsActionTypes.FETCH_BUSINESS_BANK_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS BANK END *********************** */

/** ***************** UPDATE BUSINESS BANK START *********************** */
export const updateBusinessBankStart = (updateData: any) => ({
	type: BankDetailsActionTypes.UPDATE_BUSINESS_BANK_START,
	payload: updateData,
});

export const updateBusinessBankSuccess = (successData: any) => ({
	type: BankDetailsActionTypes.UPDATE_BUSINESS_BANK_SUCCESS,
	payload: successData,
});

export const updateBusinessBankFailure = (failureData: any) => ({
	type: BankDetailsActionTypes.UPDATE_BUSINESS_BANK_FAILURE,
	payload: failureData,
});

export const updateBusinessBankResponseResetStart = () => ({
	type: BankDetailsActionTypes.UPDATE_BUSINESS_BANK_RESPONSE_RESET,
});

export const updateBusinessBankResponseChanged = () => ({
	type: BankDetailsActionTypes.UPDATE_BUSINESS_BANK_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS BANK END *********************** */

/** ***************** DELETE BUSINESS BANK START *********************** */
export const deleteBusinessBankStart = (updateData: any) => ({
	type: BankDetailsActionTypes.DELETE_BUSINESS_BANK_START,
	payload: updateData,
});

export const deleteBusinessBankSuccess = (successData: any) => ({
	type: BankDetailsActionTypes.DELETE__BUSINESS_BANK_SUCCESS,
	payload: successData,
});

export const deleteBusinessBankFailure = (failureData: any) => ({
	type: BankDetailsActionTypes.DELETE__BUSINESS_BANK_FAILURE,
	payload: failureData,
});

export const deleteBusinessBankResponseResetStart = () => ({
	type: BankDetailsActionTypes.DELETE__BUSINESS_BANK_RESPONSE_RESET,
});

export const deleteBusinessBankResponseChanged = () => ({
	type: BankDetailsActionTypes.DELETE__BUSINESS_BANK_RESPONSE_CHANGED,
});
/** ***************** DELETE BUSINESS BANK END *********************** */
